/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Container from 'components/Container';

import './SchoolViewContainer.scss';

type Props = {
  children: any,
  className?: string,
  size?: 'medium' | 'small',
};

export default function SchoolViewContainer({ children, className, size, ...props }: Props) {
  return (
    <Container
      {...props}
      className={cx('SchoolViewContainer', size && `SchoolViewContainer--${size}`, className)}>
      {children}
    </Container>
  );
}

SchoolViewContainer.defaultProps = {
  size: 'medium',
};
